import React from 'react';
import PropTypes from 'prop-types';
import { APP_BEYOND_URL } from '../../tracker.constants';
import {
  generateIframe,
  handleIframeMessage
} from '../utils/package-tracking-iframe';

export default class PackageTrackingIframeWithTrackingKeyAndCep extends React.Component {
  // eslint-disable-next-line react/static-property-placement
  static propTypes = {
    match: PropTypes.shape({
      params: {
        trackingKey: PropTypes.string.isRequired
      }
    }).isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      trackingKey: props.match.params.trackingKey
    };
  }

  componentDidMount() {
    const { trackingKey } = this.state;
    generateIframe(
      trackingKey,
      `${APP_BEYOND_URL}/rastreador/${trackingKey}/cep`
    );

    window.addEventListener('message', handleIframeMessage);
  }

  render() {
    return null;
  }
}

PackageTrackingIframeWithTrackingKeyAndCep.displayName =
  'PackageTrackingIframeWithTrackingKeyAndCep';
